import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLanguage = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "0 0 33 32",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsxs("g", {
				filter: `url(#${__svgrId}-filter0_d_2626_12652)`,
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M19.1074 3.47339C21.0902 6.59673 21.8711 10.334 21.3047 13.9899C20.5865 17.6192 18.5745 20.864 15.643 23.1208C13.6602 19.9974 12.8793 16.2602 13.4457 12.6042C14.1639 8.97499 16.1759 5.7302 19.1074 3.47339Z",
						fill: "#FFF2ED"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M15.643 23.1208C21.0685 24.0774 26.2422 20.4547 27.1989 15.0293C28.1555 9.60378 24.5328 4.43005 19.1074 3.47339C13.6819 2.51673 8.50817 6.13942 7.55151 11.5649C6.59485 16.9904 10.2175 22.1641 15.643 23.1208Z",
						fill: "#FFF2ED"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M7.55151 11.5649L27.1989 15.0293M7.55151 11.5649C6.59485 16.9904 10.2175 22.1641 15.643 23.1208M7.55151 11.5649C8.50817 6.13942 13.6819 2.51673 19.1074 3.47339M27.1989 15.0293C26.2422 20.4547 21.0685 24.0774 15.643 23.1208M27.1989 15.0293C28.1555 9.60378 24.5328 4.43005 19.1074 3.47339M19.1074 3.47339C21.0902 6.59673 21.8711 10.334 21.3047 13.9899C20.5865 17.6192 18.5745 20.864 15.643 23.1208M19.1074 3.47339C16.1759 5.7302 14.1639 8.97499 13.4457 12.6042C12.8793 16.2602 13.6602 19.9974 15.643 23.1208",
						stroke: "white",
						strokeWidth: 5,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M4.20063 17.0518C4.38609 16 4.47882 15.4741 4.75435 15.1084C4.99672 14.7868 5.33468 14.5501 5.71981 14.4324C6.15764 14.2985 6.68355 14.3913 7.73536 14.5767L12.9939 15.5039C14.0457 15.6894 14.5716 15.7821 14.9373 16.0577C15.2589 16.3 15.4956 16.638 15.6133 17.0231C15.7472 17.461 15.6544 17.9869 15.469 19.0387L14.8729 22.4192C14.6874 23.471 14.5947 23.9969 14.3192 24.3625C14.0768 24.6842 13.7388 24.9208 13.3537 25.0386C12.9159 25.1724 12.39 25.0797 11.3382 24.8942L9.76294 24.6165C9.37227 24.5476 9.17693 24.5131 8.98333 24.5185C8.81157 24.5233 8.64125 24.5513 8.47698 24.6017C8.29183 24.6586 8.11779 24.7537 7.76969 24.944L6.0657 25.8753C5.76848 26.0378 5.61987 26.119 5.51024 26.0998C5.41489 26.0831 5.33236 26.0238 5.28603 25.9388C5.23275 25.8411 5.26216 25.6743 5.32098 25.3408L5.57878 23.8787C4.9966 23.776 4.70551 23.7247 4.47797 23.6186C3.86049 23.3307 3.44353 22.7352 3.38415 22.0565C3.36226 21.8064 3.41359 21.5153 3.51624 20.9331L4.20063 17.0518Z",
						fill: "#FFC6AD",
						stroke: "white",
						strokeWidth: 5,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.1074 3.47339C21.0902 6.59673 21.8711 10.334 21.3047 13.9899C20.5865 17.6192 18.5745 20.864 15.643 23.1208C13.6602 19.9974 12.8793 16.2602 13.4457 12.6042C14.1639 8.97499 16.1759 5.7302 19.1074 3.47339Z",
				fill: "#FFF2ED"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.643 23.1208C21.0685 24.0774 26.2422 20.4547 27.1989 15.0293C28.1555 9.60378 24.5328 4.43005 19.1074 3.47339C13.6819 2.51673 8.50817 6.13942 7.55151 11.5649C6.59485 16.9904 10.2175 22.1641 15.643 23.1208Z",
				fill: "#FFF2ED"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.55151 11.5649L27.1989 15.0293M7.55151 11.5649C6.59485 16.9904 10.2175 22.1641 15.643 23.1208M7.55151 11.5649C8.50817 6.13942 13.6819 2.51673 19.1074 3.47339M27.1989 15.0293C26.2422 20.4547 21.0685 24.0774 15.643 23.1208M27.1989 15.0293C28.1555 9.60378 24.5328 4.43005 19.1074 3.47339M19.1074 3.47339C21.0902 6.59673 21.8711 10.334 21.3047 13.9899C20.5865 17.6192 18.5745 20.864 15.643 23.1208M19.1074 3.47339C16.1759 5.7302 14.1639 8.97499 13.4457 12.6042C12.8793 16.2602 13.6602 19.9974 15.643 23.1208",
				stroke: "#9B482A",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.20063 17.0518C4.38609 16 4.47882 15.4741 4.75435 15.1084C4.99672 14.7868 5.33468 14.5501 5.71981 14.4324C6.15764 14.2985 6.68355 14.3913 7.73536 14.5767L12.9939 15.5039C14.0457 15.6894 14.5716 15.7821 14.9373 16.0577C15.2589 16.3 15.4956 16.638 15.6133 17.0231C15.7472 17.461 15.6544 17.9869 15.469 19.0387L14.8729 22.4192C14.6874 23.471 14.5947 23.9969 14.3192 24.3625C14.0768 24.6842 13.7388 24.9208 13.3537 25.0386C12.9159 25.1724 12.39 25.0797 11.3382 24.8942L9.76294 24.6165C9.37227 24.5476 9.17693 24.5131 8.98333 24.5185C8.81157 24.5233 8.64125 24.5513 8.47698 24.6017C8.29183 24.6586 8.11779 24.7537 7.76969 24.944L6.0657 25.8753C5.76848 26.0378 5.61987 26.119 5.51024 26.0998C5.41489 26.0831 5.33236 26.0238 5.28603 25.9388C5.23275 25.8411 5.26216 25.6743 5.32098 25.3408L5.57878 23.8787C4.9966 23.776 4.70551 23.7247 4.47797 23.6186C3.86049 23.3307 3.44353 22.7352 3.38415 22.0565C3.36226 21.8064 3.41359 21.5153 3.51624 20.9331L4.20063 17.0518Z",
				fill: "#FFC6AD",
				stroke: "#9B482A",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
				id: `${__svgrId}-filter0_d_2626_12652`,
				x: 203788e-9,
				y: .819824,
				width: 30.7325,
				height: 30.4232,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.76033 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .440084 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2626_12652"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2626_12652",
						result: "shape"
					})
				]
			}) })
		]
	});
};
export default SvgLanguage;
